import React from "react";
import Logo from "../../assets/sloth/smsc_logo.png";
import Link from "../../utils/link";
import OpenSea from "../OpenSea";

const MenuItems = [
  { name: "Sanctuary", link: "/#sanctuary" },
  { name: "Roadmap", link: "/#roadmap" },
  { name: "Team", link: "/#team" },
  { name: "FAQs", link: "/#faqs" },
];



const Nav = () => {
  return (
    <nav className="absolute inset-0 w-full h-fit z-[2] text-[16px] font-bold tk-fatfrank">
      <div className="container-theme py-[22px] w-full grid grid-cols-3">
        <img src={Logo} alt="SMS Logo" className="w-[90px] lg:w-[124px] lg:h-[124px]" />

        <div className="hidden lg:flex items-center justify-center">
        <ul className="flex button-padding bg-[#E6FFF1] space-x-[24px] w-fit h-fit">
          {MenuItems.map((item, index) => {
            return (
              <li key={index}>
                <Link to={item.link}>{item.name}</Link>
              </li>
            );
          })}
        </ul>
        </div>

     
        <div className="flex items-center justify-end col-span-2 lg:col-span-1">

        <ul>

                <OpenSea/>

        </ul>
        </div>
      </div>
    </nav>
  );
};

export default Nav;
